// src/components/registration/SuccessScreen.tsx
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { CheckCircle } from "lucide-react";

interface SuccessScreenProps {
  onGoHome: () => void;
}

export function SuccessScreen({ onGoHome }: SuccessScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
          <CardTitle>Registration Completed!</CardTitle>
          <CardDescription>
            Thank you for registering. Your profile has been submitted and is
            being evaluated. You will receive further instructions via email.
          </CardDescription>
        </CardHeader>
        {/* <CardContent className="text-center">
          <Button onClick={onGoHome} className="mt-4">
            Go to Home
          </Button>
        </CardContent> */}
      </Card>
    </div>
  );
}
